import { Component, Input, OnInit } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { CargoDetailComponent } from "src/app/modules/cargo/cargo-detail/cargo-detail.component";
import { Utils } from 'src/app/core/resources/utils';
import { ModalEnum } from 'src/app/core/enums/modal.enum';

@Component({
  selector: 'app-assigned-cargo-item-list',
  templateUrl: './assigned-cargo-item-list.component.html',
  styleUrls: ['./assigned-cargo-item-list.component.scss'],
  providers: [CargoManager]
})
export class AssignedCargoItemListComponent implements OnInit {

  @Input() cargo: Cargo;

  constructor(
    public cargoManager: CargoManager,
    public utils: Utils,
    public matDialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  public openDetail(cargo: Cargo): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.utils.clone(cargo)
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(CargoDetailComponent, dialogConfig);
  }
}
